import { __extends } from "tslib";
import { deserializeAws_restJson1_1SendMessagesCommand, serializeAws_restJson1_1SendMessagesCommand } from "../protocols/Aws_restJson1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var SendMessagesCommand = /** @class */ (function (_super) {
    __extends(SendMessagesCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function SendMessagesCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    SendMessagesCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    SendMessagesCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1_1SendMessagesCommand(input, context);
    };
    SendMessagesCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1_1SendMessagesCommand(output, context);
    };
    return SendMessagesCommand;
}($Command));
export { SendMessagesCommand };
//# sourceMappingURL=SendMessagesCommand.js.map